<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.783,21.75c-0.203,0-0.4-0.084-0.541-0.23c-0.139-0.145-0.213-0.334-0.209-0.535c0.004-0.2,0.086-0.387,0.231-0.526
		l18.75-18c0.14-0.135,0.325-0.209,0.519-0.209c0.203,0,0.4,0.084,0.541,0.231c0.139,0.144,0.213,0.334,0.209,0.535
		c-0.004,0.2-0.086,0.387-0.23,0.526l-18.75,18C3.162,21.676,2.977,21.75,2.783,21.75z"/>
	<path d="M11.988,20.25l-0.11,0.001c-1.048,0-2.103-0.163-3.137-0.483c-0.395-0.123-0.616-0.544-0.494-0.938
		c0.098-0.316,0.386-0.528,0.717-0.528c0.075,0,0.15,0.011,0.222,0.034c0.888,0.276,1.8,0.416,2.709,0.416l0.249,0.001
		c3.853,0,7.756-2.786,10.125-5.393c0.312-0.346,0.312-0.871-0.002-1.22c-0.891-0.978-1.887-1.871-2.959-2.653
		c-0.162-0.118-0.268-0.292-0.299-0.49c-0.031-0.198,0.017-0.396,0.135-0.558c0.141-0.193,0.367-0.308,0.606-0.308
		c0.159,0,0.312,0.05,0.442,0.144c1.153,0.841,2.225,1.803,3.187,2.858c0.832,0.923,0.832,2.312,0.003,3.233
		c-2.586,2.846-6.895,5.886-11.237,5.886L11.988,20.25z"/>
	<path d="M3.778,17.011c-0.166,0-0.329-0.056-0.46-0.158c-0.963-0.748-1.869-1.584-2.693-2.486
		c-0.832-0.924-0.833-2.313-0.003-3.234c2.586-2.845,6.896-5.884,11.236-5.884l0.237,0.001c0.846,0,1.687,0.102,2.5,0.305
		c0.401,0.1,0.646,0.507,0.547,0.909c-0.083,0.335-0.383,0.569-0.728,0.569c-0.061,0-0.122-0.008-0.182-0.022
		c-0.694-0.173-1.41-0.26-2.129-0.26l-0.229,0c-3.863,0-7.771,2.785-10.14,5.391c-0.312,0.346-0.312,0.871,0.002,1.22
		c0.763,0.835,1.606,1.613,2.503,2.31c0.158,0.123,0.259,0.3,0.284,0.499c0.025,0.199-0.029,0.395-0.152,0.553
		C4.228,16.905,4.012,17.011,3.778,17.011z"/>
	<path d="M8.25,13.5c-0.413,0-0.75-0.336-0.75-0.75c0-1.2,0.468-2.329,1.318-3.18c0.85-0.851,1.979-1.32,3.179-1.32h0
		c0.207,0,0.374,0.167,0.375,0.374l0.002,0.75c0,0.1-0.039,0.195-0.109,0.266S12.1,9.75,12,9.75c-0.801,0-1.554,0.313-2.121,0.88
		C9.312,11.197,9,11.95,9,12.75c0,0.2-0.078,0.388-0.219,0.53C8.639,13.422,8.45,13.5,8.25,13.5z"/>
	<path d="M12.001,17.25c-0.207,0-0.375-0.167-0.375-0.375l-0.001-0.75c0-0.099,0.039-0.195,0.11-0.265
		c0.07-0.071,0.166-0.11,0.265-0.11c0.802,0,1.555-0.312,2.122-0.879C14.688,14.304,15,13.55,15,12.749
		c0-0.414,0.336-0.75,0.75-0.75c0.414,0,0.75,0.336,0.75,0.75c0,1.202-0.467,2.332-1.317,3.182
		C14.333,16.781,13.203,17.25,12.001,17.25z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'view-off',
    },
    name: {
      type: String,
      required: false,
      default: 'ViewOff',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>